import React from 'react';
import bubbleGif from '../../../images/gif/bubble.gif';

const OfferHeader = () => {
    return (
        <div style={{ backgroundImage: `url(${bubbleGif})`, backgroundSize: 'cover', backgroundPosition: 'center', color: 'white', padding: '20px 20px 20px 20px', borderRadius: 20 }} className="text-center">
            <h4 data-aos="fade-up" data-aos-duration="1500" className="style-font">Be Event</h4>
            <h1 data-aos="fade-up" data-aos-duration="2000" className="fw-bolder">
                <span style={{ color: '#ff3465' }}>Offer </span><span style={{ fontSize: 20, padding: '0 3px', border: '2px solid gray', borderRadius: 5 }}>of</span> <br />
                <span style={{ color: '#ff3465' }}>best </span> events 
            </h1>
            <p data-aos="fade-up" data-aos-duration="3000">Erat scelerisque lobortis nisl sed elementum massa. Et eu viverra nisi, adipiscing mauris. Pulvinar phasellus mattis pellentesque posuere nunc.</p>
            
        </div>
    );
};

export default OfferHeader;